var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"mt-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"mt-4 col-md-6 mx-auto"},[_c('div',[_c('forgot-password')],1)])])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }